import React from 'react';
import { SvgIconProps } from '@mui/material';

export const SmallCloseIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M1.53551 1.46424L8.60658 8.53531M1.53551 8.53531L8.60658 1.46424"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default SmallCloseIcon;
